export const lyric04 = `Oh-oh, I got breaking news
And it's not about you, oh-oh
Oh-oh, I've been breaking hearts too
And I learned it all from you, oh-oh

I got my thigh highs on feel like Wonder Woman
That's when you want all in
But I'm not your woman
When my lipstick pops and I feel like Monroe
That's when you want me most, oh-oh

I'm all out of salt, I'm not gonna cry
Won't give you what you want
'Cause I look way too good tonight
I'm all out of salt, tears are running dry
Won't give you what you want
'Cause I look way too good tonight

I'm all out of salt
I'm all out of salt

Oh-oh, when I'm 'bout to celebrate
Push my head into the cake, no more
Oh-oh, you're the snake pulling my arm
Like my snakeskin Saint Laurent, oh-oh

I got my thigh highs on feel like Wonder Woman
That's when you want all in
But I'm not your woman
When my lipstick pops and I feel like Monroe
That's when you want me most, oh-oh

I'm all out of salt, I'm not gonna cry
Won't give you what you want
'Cause I look way too good tonight
I'm all out of salt, tears are running dry
Won't give you what you want
'Cause I look way too good tonight

I'm all out of salt
I'm all out of salt

Not gonna c-c-cry
Not gonna c-c-cry
Not gonna c-c-cry

I'm all out of salt, I'm not gonna cry
Won't give you what you want
'Cause I look way too good tonight
I'm all out of salt, tears are running dry
Won't give you what you want
'Cause I look way too good tonight

I'm all out of salt
I'm all out of salt`